module.exports = __webpack_public_path__ + "static/media/no_image_gochi_kid_poor.8c6893ec.png";